import { render, staticRenderFns } from "./broadcastList.vue?vue&type=template&id=51a719d6&scoped=true"
import script from "./broadcastList.vue?vue&type=script&lang=js"
export * from "./broadcastList.vue?vue&type=script&lang=js"
import style0 from "./broadcastList.vue?vue&type=style&index=0&id=51a719d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a719d6",
  null
  
)

export default component.exports